import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/shared/lib/apiClient";
import { splitsKeys } from "@/shared/lib/queryKeys";
import { SPLITS_POLL_MS } from "../splits.config";

// Polls so other officers' edits to the split board appear without a manual refresh.
export const splitsQueryOptions = queryOptions({
  queryKey: splitsKeys.all,
  queryFn: async () => unwrap(await api.GET("/api/splits")),
  refetchInterval: SPLITS_POLL_MS,
});
